import CoachVoice from './CoachVoice';

export default CoachVoice;
